<div class='circle'
     [ngClass]='{"circle--one" : type === 1,"circle--two" : type === 2, "circle--three" : type === 3}'>{{initials}}</div>
